module.exports = __webpack_public_path__ + "img/info.1561c5b7.svg";